import React from "react";

import './EmptyListPlaceHolder.css';
import { EMPTY_POLYGON_LIST_MESSAGE } from '../../constants';
import { IconLoader } from "common/IconLoader";
import SvgAF from 'components/shared/SvgAF/SvgAF';

const EmptyListPlaceHolder = () => (
  <div className="Empty_List_Placeholder">
    <div className='Empty_List_Placeholder_Triangle'>
      <SvgAF img={IconLoader.icon_triangle}/>
    </div>

    <div className="Empty_List_Placeholder_Message">
      {EMPTY_POLYGON_LIST_MESSAGE}
    </div>
  </div>
);

export default EmptyListPlaceHolder;